/**
 * 项目点
 */
 import projectInfo from "@/components/promotion/projectInfo.vue";
 import { createChartDom, removeChartDom } from "../pulgin/createPulgin";
 import { addChartsOverlay, cleanChartsOverlay } from "../pulgin/addChartOverlayPulgin";
 import { convertVueToHtml } from "../pulgin/createPulgin";
 
 export default class urbanIandscapeCharts {
     constructor() {
     }
 
     //用地详情的tip框
     showMapTip(center,name) {
         removeChartDom()//先清除
         let vm = convertVueToHtml(projectInfo, {  name: name, })
             let html = createChartDom(vm);
             cleanChartsOverlay()
             addChartsOverlay(html, center,'bottom-center','projectSpot')
     }
 
 }